<template>
  <aside
    class="main-sidebar sidebar-dark-primary elevation-4 hide-scrollbar pr-4"
    style="z-index: 200 !important"
  >
    <router-link :to="{ name: 'Dashboard' }" class="brand-link">
      <!-- <img
        src="../../assets/logo.png"
        alt="AdminLTE Logo"
        class="brand-image img-circle elevation-3"
        style="opacity: 0.8"
      /> -->
      <span class="brand-text font-weight-light"><b>PushMyROI</b></span>
    </router-link>
    <v-divider></v-divider>
    <div class="sidebar" style="height: fit-content">
      <nav class="mt-2">
        <ul
          class="nav nav-pills nav-sidebar flex-column"
          data-widget="treeview"
          role="menu"
          data-accordion="false"
        >
          <li class="nav-item ml-2">
            <router-link
              :to="{ name: 'Dashboard' }"
              class="nav-link"
              id="main_dashboard"
            >
              <em class="bi bi-house-fill mr-2" style="font-size: 20px"></em>
              <p>Main Dashboard</p>
            </router-link>
          </li>
          <li class="nav-item has-treeview menu-open"></li>
          <li class="nav-item ml-2">
            <router-link
              class="nav-link"
              :to="{ name: 'MainCont' }"
              id="website_dashboard"
            >
              <em class="mr-2 bi-speedometer2"></em>
              <p>Website Dashboard</p>
            </router-link>
          </li>
          <li class="nav-item ml-2">
            <router-link
              v-if="isDataExplorerVisible"
              class="nav-link"
              :to="{ name: 'DataExplorerWithDashboard' }"
              id="data_explorer_dashboard"
            >
              <em class="mr-2 bi-clipboard-data"></em>
              <p>Data Explorer</p>
            </router-link>
          </li>
          <!-- <li class="nav-item ml-2">
            <router-link :to="{ name: 'Website' }" class="nav-link">
              <em class="bi bi-house-fill mr-2" style="font-size: 20px"></em>
              <p>Website Dashboard</p>
            </router-link>
          </li> -->
          <li class="nav-item has-treeview" v-if="isMessagesAvailable">
            <div class="nav-link has-treeview" id="send_notification">
              <em class="mr-2 bi-bell-fill"></em>
              <p>
                Recurring Drips
                <em class="bi-chevron-right right"></em>
              </p>
            </div>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link
                  tag="div"
                  :to="{ name: 'Send' }"
                  class="nav-link"
                  id="send_schedule_dashboard"
                >
                  <em class="bi-circle mr-2 nav-icon"></em>
                  <p>Create</p>
                </router-link>
              </li>
              <!-- <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>A/B Testing</p>
                </div>
              </li> -->
              <!-- <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>Drafts</p>
                </div>
              </li> -->
              <!-- <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>Scheduled</p>
                </div>
              </li> -->
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  tag="div"
                  id="recurring"
                  :to="{ name: 'Recurring', params: { edit_id: 1000 } }"
                >
                  <em class="bi-circle mr-2 nav-icon"></em>
                  <p>Regular</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  tag="div"
                  id="recurring-tales"
                  :to="{ name: 'Recurring Tails' }"
                >
                  <em class="bi-circle mr-2 nav-icon"></em>
                  <p>Tails</p>
                </router-link>
              </li>
              <li class="nav-item" v-if="hasUserPermissionToSpamRecurring">
                <router-link
                  class="nav-link"
                  tag="div"
                  id="recurring-spam"
                  :to="{ name: 'Recurring Spam' }"
                >
                  <em class="bi-circle mr-2 nav-icon"></em>
                  <p>Spam</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  tag="div"
                  id="draft"
                  :to="{ name: 'Drafts' }"
                >
                  <em class="bi-circle mr-2 nav-icon"></em>
                  <p>Draft</p>
                </router-link>
              </li>
              <!-- <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>Timezone Scheduled</p>
                </div>
              </li> -->
              <!-- <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>Email Push</p>
                </div>
              </li> -->
              <!-- <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>RSS Newsletter Push</p>
                </div>
              </li> -->
            </ul>
          </li>
          <li class="nav-item has-treeview" v-if="isAutomationAvailable">
            <div class="nav-link has-treeview" id="automation">
              <em class="mr-2 bi-robot"></em>
              <p>
                Automation
                <em class="bi-chevron-right right"></em>
              </p>
            </div>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  tag="div"
                  id="triggered_notification"
                  :to="{ name: 'TriggeredNotifications' }"
                >
                  <em class="bi-circle mr-2 nav-icon"></em>
                  <p>Triggered Notifications</p>
                </router-link>
              </li>
            </ul>
          </li>
          <li class="nav-item has-treeview" v-if="isMessagesAvailable">
            <router-link
              tag="div"
              :to="{ name: 'MainDash', params: { edit_id: {} } }"
              class="nav-link"
              id="welcome_drips"
            >
              <i class="mr-2 bi-droplet-fill"></i>
              <p>
                Welcome Drips
                <!-- <em class="bi-chevron-right right"></em> -->
              </p>
            </router-link>
            <!-- <ul class="nav nav-treeview">
              <li class="nav-item">
                <router-link
                  tag="div"
                  :to="{ name: 'MainDash', params: { edit_id: {} } }"
                  class="nav-link"
                >
                  <em class="bi-circle mr-2 nav-icon"></em>
                  <p>Active groups</p>
                </router-link>
              </li>
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  :to="{ name: 'WelcomeDrafts', params: { edit_id: {} } }"
                  tag="div"
                >
                  <em class="bi-circle mr-2 nav-icon"></em>
                  <p>Drafts</p>
                </router-link>
              </li> -->
            <!-- <li class="nav-item"> -->
            <!-- <router-link
                  class="nav-link"
                  :to="{ name: 'WelcomeGroupDrafts', params: { edit_id: {} } }"
                  tag="div"
                >
                  <em class="bi-circle mr-2 nav-icon"></em>
                  <p>Welcome drip drafts</p>
                </router-link>
              </li> -->
            <!-- </ul> -->
          </li>
          <li class="nav-item has-treeview" v-if="isAudienceAvailable">
            <div class="nav-link" id="segmentation">
              <i class="mr-2 bi-collection-fill"></i>
              <p>Segmentation</p>
            </div>
            <ul
              class="nav nav-treeview segment"
              style="display: block; margin: 0 0 0 21px"
            >
              <li class="nav-item">
                <router-link
                  class="nav-link"
                  id="audience_creator"
                  :to="{ name: 'Audience Creator' }"
                >
                  <i class="mr-2 bi-people-fill"></i>
                  <p>Audience Creator</p>
                </router-link>
              </li>
              <!-- <li class="nav-item">
                <router-link
                  class="nav-link"
                  id="manual_segmentation"
                  :to="{ name: 'Manual Segmentation' }"
                >
                  <i class="mr-2 bi-collection"></i>
                  <p>Manual Segmentation</p>
                </router-link>
              </li> -->
            </ul>
          </li>
          <!-- <li class="nav-item has-treeview">
            <div class="nav-link">
              <i class="mr-2 bi-easel"></i>
              <p>
                <i class="bi-chevron-right right"></i>
                Automation
              </p>
            </div>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>RSS to Push</p>
                </div>
              </li>
              <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>RSS Newsletter</p>
                </div>
              </li>
              <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>Conversion Funnel</p>
                </div>
              </li>
              <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>Triggered Notifications</p>
                </div>
              </li>
            </ul>
          </li> -->
          <!-- <li class="nav-item has-treeview">
            <div class="nav-link">
              <i class="mr-2 bi-bar-chart-fill"></i>
              <p>
                <i class="bi-chevron-right right"></i>
                Analytics
              </p>
            </div>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>Sent Notifications</p>
                </div>
              </li>
              <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>Subscribers</p>
                </div>
              </li>
              <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>Subscriber Information</p>
                </div>
              </li>
              <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>Geo Location</p>
                </div>
              </li>
              <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>Browser/Devices</p>
                </div>
              </li>
            </ul>
          </li> -->
          <!-- <li class="nav-item has-treeview">
            <div class="nav-link">
              <i class="mr-2 bi-gear-fill"></i>
              <p>
                Settings
                <i class="bi-chevron-right right"></i>
              </p>
            </div>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>Website</p>
                </div>
              </li>
              <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>Manage Users</p>
                </div>
              </li>
              <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>Opt-in Box</p>
                </div>
              </li>
              <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>Opt-in Box Safari/Firefox</p>
                </div>
              </li>
              <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>Widget(Bell Icon)</p>
                </div>
              </li>
              <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>Safari Configuration</p>
                </div>
              </li>
              <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>REST API Key</p>
                </div>
              </li>
              <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>Customize Strings</p>
                </div>
              </li>
              <li class="nav-item">
                <div class="nav-link">
                  <i class="bi-circle mr-2 nav-icon"></i>
                  <p>Privacy</p>
                </div>
              </li>
            </ul>
          </li> -->
          <li class="nav-item has-treeview" v-if="isIntegrateAvailable">
            <router-link
              tag="div"
              :to="{ name: 'Integrate' }"
              class="nav-link"
              id="integrate"
            >
              <i class="mr-2 bi-code-slash"></i>
              <p>Integrate</p>
            </router-link>
          </li>
          <!-- <li class="nav-item has-treeview">
            <div class="nav-link">
              <i class="mr-2 bi-file-earmark-fill"></i>
              <p>Documentation</p>
            </div>
          </li> -->
          <li class="nav-item has-treeview">
            <div @click="logoutMethod" class="nav-link" id="sign_out">
              <em class="nav-icon mr-2 bi-box-arrow-right"></em>
              <p>Sign Out</p>
            </div>
          </li>
        </ul>
      </nav>
    </div>
    <small class="position-absolute" style="bottom: 0; font-size: 9px"
      >v{{ version }}</small
    >
  </aside>
</template>

<script>
import $ from "jquery";
import { version } from "../../../package.json";
// import User from "../../apis/User";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AsideBar",
  data() {
    return {
      version: version,
    };
  },
  computed: {
    ...mapGetters(["roles", "permissions"]),
    isViewerRole() {
      return this.roles.includes("viewer");
    },
    isAudienceAvailable() {
      return (
        this.permissions.includes("menu.domain.audience") ||
        this.permissions.includes("menu.admin.panel")
      );
    },
    isIntegrateAvailable() {
      return (
        this.permissions.includes("menu.domain.integrate") ||
        this.permissions.includes("menu.admin.panel")
      );
    },
    isMessagesAvailable() {
      return (
        this.permissions.includes("menu.domain.messages") ||
        this.permissions.includes("menu.admin.panel")
      );
    },
    isAutomationAvailable() {
      return (
        this.permissions.includes("menu.domain.automation") ||
        this.permissions.includes("menu.admin.panel")
      );
    },
    hasUserPermissionToSpamRecurring() {
      //return true;
      return this.permissions.includes("menu.recurring.spam");
    },
    isDataExplorerVisible() {
      return this.permissions.includes("menu.analytics.data_explorer");
    },
  },
  created() {
    $('[data-widget="treeview"]').Treeview("init");
  },
  methods: {
    ...mapActions(["logout", "resetDomains"]),
    logoutMethod() {
      this.resetDomains();

      this.logout().then(() => {
        localStorage.removeItem("auth");
        //localStorage.removeItem("login");
        this.$router.push({ name: "Home" });
      });
    },
  },
};
</script>

<style>
.sidebar {
  overflow: unset !important;
}
.nav-item {
  cursor: pointer;
}
.v-treeview-node__label,
.v-treeview-node__children {
  font-size: 12px;
}
.v-treeview-node__children {
  margin-left: 21px;
}
.nav-link.v-tree {
  height: 45px;
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-start;
}
.v-treeview-node__root {
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-start;
}
.v-treeview-node__toggle {
  margin: 0 28px;
}
.sidebar::-webkit-scrollbar {
  display: none !important;
}
.sidebar::-moz-scrollbar {
  display: none !important;
}
.sidebar::-o-scrollbar {
  display: none !important;
}
.sidebar::-ms-scrollbar {
  display: none !important;
}
.sidebar {
  width: 100%;
}
.nav-sidebar .nav-link > p > .right {
  right: 6rem;
}
.nav-link,
.v-treeview-node__label {
  color: #c2c7d0 !important;
}
.has-treeview {
  padding: 0 0 0 8px;
}
i.right,
em.right {
  right: 2rem !important;
}
</style>
